/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import { css } from "styled-components";
import {FiraSansBold} from 'components/Text';
import {mediaHelper} from "../../utils/src";
import Colors from 'constants/Colors';

const generateCustomBorder = (customColor, isHeader, isContent, isExpanded) => {
  if (customColor) {
    if (isHeader) {
      return css`
        background: ${customColor};
        border-radius: ${isExpanded ? '10px 10px 0 0' : '10px'};
        border-top: 2px solid ${customColor};
        border-left: 2px solid ${customColor};
        border-right: 2px solid ${customColor};
        border-bottom: ${!isExpanded ? `2px solid ${customColor}` : ''};
      `;
    }
    if (isContent) {
      return css`
        padding: 0 10px;
        border-bottom: ${({ isExpanded }) => isExpanded ? `2px solid ${customColor}` : ''};
        border-left: ${({ isExpanded }) => isExpanded ? `2px solid ${customColor}` : ''};
        border-right: ${({ isExpanded }) => isExpanded ? `2px solid ${customColor}` : ''};
      `;
    }
  }
  return '';
};

export const Container = styled.div`
  background-color: ${Colors.WHITE};
  margin-top: 10px;
  margin-bottom: 10px;
  border-top: 2px solid ${Colors.GRAY[5]};
  width: 100%;
`;

export const CardHeader = styled.div`
  display: flex;
  color: ${({ customColor }) => customColor ? Colors.WHITE : Colors.PRIMARY1 };
  justify-content: space-between;
  text-transform: uppercase;
  font-weight:${FiraSansBold};
  font-family:'Fira Sans', sans-serif;
  cursor: pointer;

  ${({ isExpanded, customColor }) => generateCustomBorder(customColor, true, false,  isExpanded )};

  padding: ${({ noTitlePadding }) => noTitlePadding ? '10px 0px' : '10px'} !important;
  font-size: 14px;
  
  ${mediaHelper.sm`
    padding: 10px 0px;
    font-size: 18px;
  `}
  
  .icon-arrow-up-primary-color {
    width: 40px;
    height: 20px;
    min-width: 20px;
    transition: transform ease-in-out 200ms;
    
    &:before{
      background-size: 100%;
      width: 80%;
      height: 80%;
      margin: 10%;
    }
    
    &.closed {
      transform: rotate(180deg);
    }
  }
`;

export const Title = styled.div`
  display: flex;
  alignItems: center;
  ${({ isChild }) => isChild && "margin-left:20px"};
`;

export const CardContent = styled.div`
  background-color: #FFF;
  color: #000;
  
  flex-grow: 1;
  border-radius: 0px 0px 10px 10px;
  overflow: hidden;
  max-height: 0px;

  ${({ isExpanded, customColor }) => generateCustomBorder(customColor, false, true,  isExpanded )};
  
  ${mediaHelper.sm`
    border-radius: 0px 0px 15px 15px;
  `}
  
  ${mediaHelper.md`
    border-radius: 0px 0px 20px 20px;
  `}
  
  &.expanding {
    max-height: 2500px;
  }
  
  &.collapsing {
    max-height: 0;
  }
  
  &.expanded {
    max-height: unset;
    overflow: initial;
  }

  &.before-collapsing { 
    max-height: 2500px;
  }
  
  transition: all ease-in-out 500ms;
`;

export const Expandable = styled.div`
  padding: 5px;
  
  ${mediaHelper.sm`
    padding: 10px 0px;
  `}
`;